<template>
  <div class="auction-list-container" ref="formContainer">
    <div class="whats-news-area">
      <div class="container">
        <div class="filter">
          <input
            class="input-search"
            placeholder="Nhập từ khóa tìm kiếm"
            v-model="searchText"
            @keyup.enter="handleSearch"
          />
          <app-button @click="handleSearch" :disabled="isLoading">
            Tìm kiếm
          </app-button>
        </div>
        <app-loading :loading="isLoading" />
        <div class="tab-content" id="nav-tabContent" v-if="!isLoading">
          <div class="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
            <div class="whats-news-caption" ref="auctionList">
              <auction-list :data="data" />
            </div>
          </div>
        </div>
        <div class="pagination-wrapper">
          <paginate
            v-model="page"
            :page-count="totalPage"
            :page-range="5"
            :container-class="'pagination'"
            :page-class="'page-item'"
            :page-link-class="'page-link-item'"
            :prev-class="'prev-item'"
            :prev-link-class="'prev-link-item'"
            :next-class="'next-item'"
            :next-link-class="'next-link-item'"
            :break-view-class="'break-view'"
            :break-view-link-class="'break-view-link'"
            prev-text="Trang trước"
            next-text="Trang sau"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Pagination from 'vue-pagination-2';

import Auction from '@/common/api/auction';
import AuctionList from '@/components/Dashboard/AuctionList.vue';
import AppButton from '@/components/AppButton.vue';
import AppLoading from '@/components/AppLoading.vue';
import CONFIG from '@/common/config';

export default {
  name: 'AuctionListPage',
  components: { AuctionList, AppButton, Pagination, AppLoading },
  data() {
    return {
      data: [],
      page: 1,
      pageSize: 10,
      totalElements: 0,
      searchText: '',
      preSearchText: '',
      isLoading: false
    };
  },
  mounted() {
    this.getAuctionList();
  },
  computed: {
    totalPage() {
      return Math.floor(this.totalElements / this.pageSize);
    }
  },
  watch: {
    page() {
      this.getAuctionList();
    }
  },
  methods: {
    show() {},
    getAuctionList() {
      this.isLoading = true;
      Auction.getListAuction({
        typeId: CONFIG.ID_AUCTION_DO,
        pageIndex: this.page,
        pageSize: this.pageSize,
        keyword: this.searchText
      })
        .then(({ data }) => {
          this.data = data.Data.Data;
          this.totalElements = data.Data.Total;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    handleSearch() {
      if (this.preSearchText === this.searchText) {
        return;
      }
      this.page = 1;
      this.getAuctionList();
      this.preSearchText = this.searchText;
    }
  }
};
</script>

<style scoped>
.auction-list-container {
  margin-bottom: 12px;
}
.filter {
  margin: 12px 0;
}
.pagination-wrapper {
  margin-top: 12px;
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/views/AuctionListPage.vue